angular.module("app").directive("unicornTopFiveLogoColor", () => {
  let link = (scope) => {

  };

  return {
    restrict: "E",
    templateUrl: "app/directives/dbUnicornTopFiveLogoColor/dbUnicornTopFiveLogoColorView.html",
    link: link,
    scope: {
      data: "="
    }
  };
});
